const similarProducts = document.querySelector('.similar-products');

if ( similarProducts ) {
	const moreButton = similarProducts.querySelector('.see-more-button');
	const lessButton = similarProducts.querySelector('.see-less-button');
	const products = similarProducts.querySelectorAll('.product');
	const productsContainer = similarProducts.querySelector('.products');

	window.addEventListener('load', () => {
		showMoreLess(window.innerWidth);
	});

	window.addEventListener('resize', () => {
		showMoreLess(window.innerWidth);
	});

	function showMoreLess(width) {
		if (width < 1024 && products.length > 2) {
			const firstHeight = products[0].offsetHeight;
			const thirdHeight = products[2].offsetHeight;
			const height = firstHeight + thirdHeight;
			moreButton.style.display = 'initial';
			lessButton.style.display = 'none';

			productsContainer.style.height = height + 'px';

			moreButton.addEventListener('click', () => {
				productsContainer.style.height = 'auto';
				moreButton.style.display = 'none';
				lessButton.style.display = 'initial';
			});
			lessButton.addEventListener('click', () => {
				productsContainer.style.height = height + 'px';
				moreButton.style.display = 'initial';
				lessButton.style.display = 'none';
			})
		}

		if (width >= 1024 && products.length > 4) {
			const height = products[0].offsetHeight;
			moreButton.style.display = 'initial';
			lessButton.style.display = 'none';

			productsContainer.style.height = height + 'px';

			moreButton.addEventListener('click', () => {
				productsContainer.style.height = 'auto';
				moreButton.style.display = 'none';
				lessButton.style.display = 'initial';
			});
			lessButton.addEventListener('click', () => {
				productsContainer.style.height = height + 'px';
				moreButton.style.display = 'initial';
				lessButton.style.display = 'none';
			})
		}
	}
}
